export default "__VITE_ASSET__BLfH$tK1__"